import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header style={{
      background: '#000000',
      borderBottom: '1px solid rgba(255, 255, 255, 0.25)',
      padding: '16px 7.6923%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'fixed',
      top: 0,
      width: '100%',
      height: '80px',
      zIndex: 10,
      boxSizing: 'border-box'
    }}>
      <div style={{
        fontSize: '24px',
        fontWeight: 600,
        color: '#FFFFFF',
        letterSpacing: '-0.5px'
      }}>
        UNIVERSE ENGINE
      </div>
      
      {/* Desktop Navigation */}
      <nav className="desktop-nav" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '32px'
      }}>
        <a href="#paradigm" style={{
          color: '#4D4D4D',
          textDecoration: 'none',
          fontSize: '18px',
          fontWeight: 400,
          transition: 'color 0.3s ease'
        }}
        onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
        onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
          Theory
        </a>
        <a href="#proof" style={{
          color: '#4D4D4D',
          textDecoration: 'none',
          fontSize: '18px',
          fontWeight: 400,
          transition: 'color 0.3s ease'
        }}
        onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
        onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
          Predictions
        </a>
        <a href="#implications" style={{
          color: '#4D4D4D',
          textDecoration: 'none',
          fontSize: '18px',
          fontWeight: 400,
          transition: 'color 0.3s ease'
        }}
        onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
        onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
          Implications
        </a>
      </nav>

      {/* Mobile Menu Button */}
      <button 
        className="mobile-menu-btn"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{
          background: 'none',
          border: 'none',
          color: '#FFFFFF',
          cursor: 'pointer',
          padding: '8px',
          display: 'none'
        }}>
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="mobile-nav" style={{
          position: 'fixed',
          top: '80px',
          left: 0,
          right: 0,
          background: '#000000',
          borderBottom: '1px solid rgba(255, 255, 255, 0.25)',
          padding: '20px',
          display: 'none',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <a href="#paradigm" onClick={() => setIsMenuOpen(false)} style={{
            color: '#FFFFFF',
            textDecoration: 'none',
            fontSize: '18px',
            fontWeight: 400,
            padding: '12px 0'
          }}>
            Theory
          </a>
          <a href="#proof" onClick={() => setIsMenuOpen(false)} style={{
            color: '#FFFFFF',
            textDecoration: 'none',
            fontSize: '18px',
            fontWeight: 400,
            padding: '12px 0'
          }}>
            Predictions
          </a>
          <a href="#implications" onClick={() => setIsMenuOpen(false)} style={{
            color: '#FFFFFF',
            textDecoration: 'none',
            fontSize: '18px',
            fontWeight: 400,
            padding: '12px 0'
          }}>
            Implications
          </a>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
          .mobile-nav {
            display: flex !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;